import React, { useContext, useState } from 'react';
import { Typography, Box, Button, useMediaQuery, useTheme, Grid } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { StepButtonBar } from '../OtherRequirementWizard/StepButtonBar';
import { StepProps } from './types';
import { UserContext } from '../../../../../Context/UserContext/UserContext';
import UpdateConnectionInfo from './UpdateConnectionInfo';

const PRIMARY = '#c4122f';

interface Step2LawActionSelectProps extends StepProps {
  selectedAction?: 'new-unit' | 'existing-unit' | 'disconnect-unit';
  onActionSelect: (action: 'new-unit' | 'existing-unit' | 'disconnect-unit') => void;
  currentStepName: string;
  updateConnectionInfo: any;
  setUpdateConnectionInfo: (info: any) => void;
}

const Step2LawActionSelect = ({
  onNext,
  onBack,
  onCancel,
  isFirstStep,
  selectedAction,
  onActionSelect,
  currentStepName,
  updateConnectionInfo,
  setUpdateConnectionInfo,
}: Step2LawActionSelectProps) => {
  const [localSelectedAction, setLocalSelectedAction] = useState<'new-unit' | 'existing-unit' | 'disconnect-unit' | undefined>(selectedAction);
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const paperPadding = isMobile ? theme.spacing(3) : theme.spacing(8);
  const { getCompanyUnitName } = useContext(UserContext);
  const handleSelectAction = (action: 'new-unit' | 'existing-unit' | 'disconnect-unit') => {
    setLocalSelectedAction(action);
  };

  const handleNext = () => {
    if (localSelectedAction) {
      onActionSelect(localSelectedAction);
      onNext();
    }
  };

  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          display: 'flex',
          width: '100%',
          gap: '10px',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'stretch',
        }}
      >
        <div
          style={{
            width: isMobile ? '100%' : 'calc(50% - 5px)',
            flexShrink: 0,
            padding: paperPadding,
            backgroundColor: '#f7f0f1',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '350px',
          }}
        >

          <Box style={{ maxWidth: '450px', width: '100%' }}>
            <Grid container spacing={3} justifyContent="flex-start">
              <Grid
                item
                xs={12}
                style={{ display: 'flex', justifyContent: 'center' }}
              >
                <Button
                  variant={'outlined'}
                  onClick={() => handleSelectAction('new-unit')}
                  style={{
                    padding: isMobile ? '18px 24px' : '22px 32px',
                    fontSize: isMobile ? '14px' : '16px',
                    fontWeight: 700,
                    color: localSelectedAction === 'new-unit' ? '#fff' : PRIMARY,
                    background: localSelectedAction === 'new-unit' ? PRIMARY : 'transparent',
                    width: '100%',
                    minWidth: '250px',
                    borderRadius: '8px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    transition: 'all 0.2s ease',
                    border: `2px solid ${PRIMARY}`,
                  }}
                >
                  {formatMessage(
                    { id: 'law-portal.manage.edit-law.addCompanyUnit' },
                    { alias: getCompanyUnitName(formatMessage, true) },
                  )}
                </Button>
              </Grid>
              <Grid
                item
                xs={12}
                style={{ display: 'flex', justifyContent: 'center' }}

              >
                <Button
                  variant={'outlined'}
                  onClick={() => handleSelectAction('existing-unit')}
                  style={{
                    padding: isMobile ? '18px 24px' : '22px 32px',
                    fontSize: isMobile ? '14px' : '16px',
                    fontWeight: 700,
                    color: localSelectedAction === 'existing-unit' ? '#fff' : PRIMARY,
                    background: localSelectedAction === 'existing-unit' ? PRIMARY : 'transparent',
                    width: '100%',
                    minWidth: '250px',
                    borderRadius: '8px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    transition: 'all 0.2s ease',
                    border: `2px solid ${PRIMARY}`,
                  }}
                >
                  {formatMessage({ id: 'law-portal.manage.update-laws.action.existing-units' })}
                </Button>
              </Grid>
              <Grid
                item
                xs={12}
                style={{ display: 'flex', justifyContent: 'center' }}
              >
                <Button
                  variant={'outlined'}
                  onClick={() => handleSelectAction('disconnect-unit')}
                  style={{
                    padding: isMobile ? '18px 24px' : '22px 32px',
                    fontSize: isMobile ? '14px' : '16px',
                    fontWeight: 700,
                    color: localSelectedAction === 'disconnect-unit' ? '#fff' : PRIMARY,
                    background: localSelectedAction === 'disconnect-unit' ? PRIMARY : 'transparent',
                    width: '100%',
                    minWidth: '250px',
                    borderRadius: '8px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    transition: 'all 0.2s ease',
                    border: `2px solid ${PRIMARY}`,
                  }}
                >
                  {formatMessage({ id: 'law-portal.manage.update-laws.action.disconnect-units' })}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </div>
        <UpdateConnectionInfo
          updateConnectionInfo={updateConnectionInfo}
          currentStepName={currentStepName}
          onUpdate={setUpdateConnectionInfo}
        />
      </div>

      <Box>
        <StepButtonBar
          onCancel={onCancel}
          onBack={onBack}
          onNext={handleNext}
          nextLabel="form.next"
          nextDisabled={!localSelectedAction}
          formatMessage={formatMessage}
          showBack={!isFirstStep}
        />
      </Box>
    </div>
  );
};

export default Step2LawActionSelect;
